function prepareTransition(el, callback) {
  el.addEventListener("transitionend", function removeTransitionClass() {
    el.classList.remove("is-transitioning");
    el.removeEventListener("transitionend", removeTransitionClass);
  });

  el.classList.add("is-transitioning");
  el.offsetWidth; // force reflow

  if (typeof callback === "function") {
    callback();
  }
}

function openLoginDrawer() {
  const drawer = document.getElementById("LoginDrawer");
  const html = document.documentElement;
  const trigger = document.querySelector(".js-drawer-open-login");

  prepareTransition(drawer, function () {
    drawer.style.display = "block";
    drawer.classList.add("drawer--is-open");
  });

  drawer.setAttribute("tabindex", "-1");
  html.classList.add("js-drawer-open", "lock-scroll");
  if (trigger) trigger.setAttribute("aria-expanded", "true");
}

function closeLoginDrawer() {
  const drawer = document.getElementById("LoginDrawer");
  const html = document.documentElement;
  const trigger = document.querySelector(".js-drawer-open-login");

  html.classList.remove("js-drawer-open");
  html.classList.add("js-drawer-closing");

  drawer.classList.remove("drawer--is-open");

  setTimeout(() => {
    html.classList.remove("js-drawer-closing", "lock-scroll");
    drawer.style.display = "none";
    drawer.removeAttribute("tabindex");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
  }, 300); // match transition duration
}

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelector(".js-drawer-open-login")
    ?.addEventListener("click", function (e) {
      e.preventDefault();
      openLoginDrawer();
    });

  document
    .querySelector(".main-content")
    ?.addEventListener("click", function () {
      const drawer = document.getElementById("LoginDrawer");
      if (
        document.documentElement.classList.contains("js-drawer-open") &&
        drawer?.classList.contains("drawer--is-open")
      ) {
        closeLoginDrawer();
      }
    });
});
